var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-card',{staticClass:"mb-0",attrs:{"no-body":""}},[_c('b-card-header',[_c('h5',{staticClass:"mb-[0.43rem]"},[_vm._v(" Generate Bills ")])]),_c('b-card-body',[_c('bill-generate-wizard')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }